module.exports = __webpack_public_path__ + "img/parthner-3.b9808da9.svg";